import {updateLabelConfig} from '../../../data/labelInfos/index.js'
import {FEDEX, FEDEX_360} from '../../../common/constants/ShipperNames.js'
import ConfigTextInput from './ConfigTextInput.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {
  defaultValidLabelPropertiesFunc,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
} from './useLabelProperty.js'

const LABEL_PROPERTY = 'department_number'
const VALID_SHIPPER_TYPES = [FEDEX, FEDEX_360]

export default function DepartmentNumber() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = DepartmentNumber.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigTextInput
      label="Department Number"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {[labelProperty]: value})

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
    />
  )
}

DepartmentNumber.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
